module.exports = __webpack_public_path__ + "static/img/bargain.a97dd472.png";